export default "__VITE_ASSET__CdBQw7$P__"